// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"427":"fc4a619d","648":"28f56a91"}[chunkId] + ".chunk.js";
};